export const getGroupHasSelectedOption = options =>
  Object.values(options).some(option => option.enabled);
